export default {
      id: "select-arrow-usage",
      viewBox: "0 0 12 8",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#select-arrow",
      toString: function () {
        return this.url;
      }
    }